import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The Zendesk connector can link brands, groups, organizations, tickets, users, and sla policies.`}</p>
    <p>{`To link Zendesk:`}</p>
    <ol>
      <li parentName="ol">{`Go to the `}<a parentName="li" {...{
          "href": "https://us.posthog.com/pipeline/sources"
        }}>{`Data pipeline page`}</a>{` and the sources tab in PostHog`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`New source`}</strong>{` and select Zendesk`}</li>
      <li parentName="ol">{`Provide the subdomain of your zendesk account (`}<inlineCode parentName="li">{`https://posthoghelp.zendesk.com/`}</inlineCode>{` -> "posthoghelp" is the subdomain)`}</li>
      <li parentName="ol">{`Provide the `}<a parentName="li" {...{
          "href": "https://support.zendesk.com/hc/en-us/articles/4408889192858-Managing-access-to-the-Zendesk-API#topic_bsw_lfg_mmb"
        }}>{`API token`}</a>{` and email associated with it`}</li>
      <li parentName="ol"><em parentName="li">{`Optional:`}</em>{` Add a prefix to your table names`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Next`}</strong></li>
    </ol>
    <p>{`The data warehouse then starts syncing your Zendesk data. You can see details and progress in the `}<a parentName="p" {...{
        "href": "https://us.posthog.com/pipeline/sources"
      }}>{`data pipeline sources tab`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      